import React from 'react';

const IconWrapper = ({ icon: IconComponent, className = "", ...props }) => {
  if (!IconComponent) return null;
  
  // Check if it's a Lucide icon (function component)
  if (typeof IconComponent === 'function') {
    return <IconComponent className={className} {...props} />;
  }
  
  // It's a custom SVG component (React element)
  return React.cloneElement(IconComponent, { 
    className: className,
    ...props
  });
};

export default IconWrapper;